import "./App.css";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Homeparent from "./components/Homepage/Homeparent";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Aboutmain from "./components/About/About-main";
import Contactus from "./components/Contact-us/Contactus";
import Breadcrump from "./components/Breadcrump/Breadcrump";
import ScrollToTop from "react-scroll-to-top";
import Productdetail from "./components/Productdetail/Productdetail";
import Category from "../src/components/Category/Category";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import Login from "./components/Login/Login";
import { ToastContainer } from "react-toastify";
import Cart from "./components/Cart/Cart";
import AccountRoute from "./AccountRoute";
import Enquirysuccesspage from "./components/Enquirysuccesspage";

function App() {
  return (
    <div>
      <BrowserRouter basename="/">
        {/* <Header /> */}
        <ScrollToTop
          smooth
          component={<FontAwesomeIcon icon={faAngleUp}></FontAwesomeIcon>}
          className="scroll icon"
        />
        <Routes>
          <Route
            path="/"
            element={
              <div>
                <Homeparent />
              </div>
            }
          ></Route>
          <Route
            path="/About-Us"
            element={
              <>
                
                <Aboutmain />
                
              </>
            }
          ></Route>
          <Route
            path="/contact-us"
            element={
              <>
                <Header />
                <Breadcrump cont2="Contact Us" />
                <Contactus />
                <Footer />

              </>
            }
          ></Route>
          <Route
            path="/product-details/:slug_name"
            element={
              <div>
                <Productdetail />
              </div>
            }
          ></Route>
          <Route
            path="/category/:slug"
            element={
              <div>
                <Category />
              </div>
            }
          ></Route>

          <Route
            path="/category"
            element={
              <div>
              
                
                <Category />
              

              </div>
            }
          />

          <Route
            path="/login"
            element={
              <div>
                <Header />
                <Login />
                <Footer />

              </div>
            }
          ></Route>
          <Route
            path="/my-profile"
            element={
              <div>
                <Header />
                <AccountRoute />
                <Footer />

              </div>
            }
          ></Route>
          <Route
            path="/cart"
            element={
              <div>
                <Header />
                <Cart />
                <Footer />

              </div>
            }
          ></Route>
          <Route
            path="/enquiry-success"
            element={
              <div>
                <Header />
                <Enquirysuccesspage />
                <Footer />
              </div>
            }
          ></Route>
        </Routes>
        {/* <Footer /> */}
        <ToastContainer />
      </BrowserRouter>
    </div>
  );
}
export default App;
